<script setup>
import { useSlots } from 'vue'
const slots = useSlots()
</script>
<template>
  <div class="flex flex-row justify-between items-center p-2 shadow z-100">
    <!-- menu icon for small screens -->
    <slot
      v-if="slots.beforelogo"
      name="beforelogo"
    />

    <!-- Site logo -->
    <router-link
      to="/"
      class="inline-block"
    >
      <div class="text-gray-900">
        <svg
          width="170"
          height="32"
          version="1.1"
          viewBox="0 0 212 40"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
        >
          <path
            d="m23.353 16.719q-1.8001-0.41312-2.7245-0.41312-1.1433 0-2.092 0.77769-1.1433 0.94769-1.1433 2.4544 0 1.1665 2.092 4.4957 2.092 3.3293 2.092 6.1239 0 4.0583-3.0894 6.6586-2.9434 2.503-7.2734 2.503-3.9894 0-5.8869-0.5589-0.21889-1.1178-0.75412-3.6452-0.34058-1.3609-0.94876-3.6209 2.6758 0.65613 3.6002 0.65613 3.6246 0 3.6246-2.7461 0-1.9927-1.4596-3.5723-2.3839-2.0899-4.7679-4.2041-4.6219-4.0826-4.6219-9.6962 0-5.8566 4.3787-8.87 3.8192-2.6245 10.168-2.6245 3.6002 0 8.0762 1.0449zm18.585 6.0753-1.0945 7.4119h-12.406l-1.192-7.4119zm36.61-3.4994q0 8.5784-4.4274 14.508-4.6461 6.1968-11.895 6.1968-7.468 0-12.09-6.2455-4.3543-5.8809-4.3543-14.459 0-9.1616 4.7435-14.386 4.476-4.9089 11.701-4.9089 7.1031 0 11.579 4.9332 4.7436 5.2491 4.7436 14.362zm-11.701 4.277q0-6.7558-4.5733-6.7558-4.4516 0-4.4516 6.8044 0 2.7217 1.1674 5.079 1.3136 2.6488 3.2354 2.6488 1.8731 0 3.3083-2.6974 1.3136-2.4544 1.3136-5.079zm38.8 7.825q-0.24361 0.97203-0.90028 3.6695-0.34011 1.5796-0.58371 3.6938h-22.015q-0.12121-5.7108-0.60842-18.809-0.31657-6.7072-1.1427-18.518h16.882l-1.3865 30.96q2.3596 0 7.0788-0.51035 0.97325-0.09758 2.6759-0.48601zm17.831-8.6027-1.0945 7.4119h-12.406l-1.1919-7.4119zm35.418-9.0644q0 4.3742-2.0919 7.5577-1.7758 2.6731-4.4274 3.791 1.7029 0.72902 2.7732 2.4058 1.0697 1.6768 1.0697 3.5723 0 4.7145-5.0354 6.9016-3.8922 1.7011-10.217 1.7011-5.449 0-11.701-0.89914-0.17064-5.6622-0.70492-18.469-0.36482-6.8773-1.0945-18.858 4.6219-0.89914 11.701-0.89914 19.728 0 19.728 13.196zm-9.9006 4.5686q0-1.8712-1.5082-2.8676-1.3622-0.89914-3.5758-0.85058l-0.36482 7.3147q5.449 0.19445 5.449-3.5966zm-0.8026 11.543q0-2.819-4.0381-2.819-0.41307 0-0.85203 0.0482l-0.14592 5.9538q5.0354 0.21867 5.0354-3.1835zm29.191-28.408-0.94853 19.854q-0.26715 6.4155-0.63196 17.473h-13.647l-1.6542-37.327zm34.616 17.861q0 8.5784-4.4274 14.508-4.6461 6.1968-11.895 6.1968-7.468 0-12.09-6.2455-4.3544-5.8809-4.3544-14.459 0-9.1616 4.7436-14.386 4.476-4.9089 11.701-4.9089 7.1031 0 11.579 4.9332 4.7436 5.2491 4.7436 14.362zm-11.701 4.277q0-6.7558-4.5732-6.7558-4.4516 0-4.4516 6.8044 0 2.7217 1.1674 5.079 1.3136 2.6488 3.2354 2.6488 1.873 0 3.3083-2.6974 1.3136-2.4544 1.3136-5.079z"
            style="stroke-width: 0.26458"
            aria-label="S-Ol-Bio"
          />
        </svg>
      </div>
    </router-link>
    <div class="grow">
      <slot
        v-if="slots.mainarea"
        name="mainarea"
      />
    </div>

    <slot
      v-if="slots.rightarea"
      name="rightarea"
    />
  </div>
</template>
